import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { format } from 'date-fns';

import { BulletIcon } from '../../../../components/common/BulletIcon/BulletIcon';
import ProductCard from '../../../../containers/POS/Items/Products';
import { TokenList } from '../../../../features/Services/Tokens';
import { ErrorDiv } from './ErrorDiv';
import { LateBookingPayment } from './LateBookingPayment';

import styles from './bookingComponentStyles.module.scss';


export const SelectTokens = ({
    checkServiceAndUserTokens,
    userTokens,
    activeService,
    selectedBookings,
    setSelectedProduct,
    selectedUser,
    handleError,
    matchedTokens,
    slots,
    handleBooking,
    handleAddToCart,
    registerId,
    fromPOS,
    errors,
    lateBooking=false,
    handleLateBooking=null,
    ...props
})=>{

    //if a service takes more than one token, notify staff if there is a cheaper option
    const checkForCheapestToken= (service)=>{
        if(service?.products?.length > 1){
            let token = service?.products.reduce((acc, product) => {
                const currentPrice = product.variants[0].price; //tokesn should only ever have one variant
                const accPrice = acc.variants[0].price;
                return currentPrice < accPrice ? product : acc;
            })?.id;
            return token;
        }
    }

    const handleSelectedProduct=(token, amount)=>{
        checkServiceAndUserTokens(userTokens, activeService?.products, selectedBookings)
        setSelectedProduct(token);
        handleAddToCart(token, amount);
    }

    if (lateBooking && handleLateBooking) {
        return(
            <div className = {styles["select-tokens-wrapper"]}>
                <LateBookingPayment
                    activeService={activeService}
                    matchedTokens={matchedTokens}
                    slots={slots}
                    handleLateBooking={handleLateBooking}
                    errors={errors}
                />
            </div>
        )
    }

    return(
        <div className = {styles["select-tokens-wrapper"]}>
            {userTokens?.length > 0&& selectedUser && 
                <div>
                    {selectedUser?.first_name} currently has the following tokens:
                    <TokenList
                        userId={selectedUser?.id}
                        accordionProps={{primary: false, importedStyle: "list"}}
                    />
                </div>
            }
            <hr />
            {matchedTokens?.length > 0 &&
                <div>
                    <p>
                        <span>The user needs a total of {slots?.length} tokens.</span>
                        <span>
                            The user has {matchedTokens?.length} type of token{matchedTokens?.length > 1 ? "s" : ""} {" "}
                            that match{matchedTokens?.length > 1 ? "" : "es"} the service - 
                        </span>
                    </p>

                    {matchedTokens?.map((token, index) => (
                        <div key={index}>
                            <BulletIcon bulletType="openCircle" /> {token?.product_name} can be used for this service. They have {token?.number_of_tokens}/{slots?.length} tokens/required.
                            {token?.number_of_tokens >= slots?.length ?
                            <p className={styles["enough-tokens-p"]}>
                                <span> They have enough tokens to cover the booking.</span>
                                <br />
                                <Button onClick={()=>handleBooking(token)}>Use These Tokens</Button>
                            </p>
                            :
                                <span> They do not have enough tokens to cover the booking.</span>
                            }
                        </div>
                    ))}
                </div>
            }
            {matchedTokens?.length === 0 &&
                <span>
                    The user has no matching tokens that can be used for this service.
                </span>
            }
            {selectedBookings && selectedBookings?.length > 0 &&
                <>
                    {matchedTokens.text}
                </>
            }
            {registerId &&activeService && activeService?.products?.map((token)=>{
                let cheapestId = checkForCheapestToken(activeService);
                let price = token.variants[0].price;
                let matchedToken = matchedTokens?.filter((matched)=>matched.id === token.id)
                let multiplier = matchedToken?.length ? slots?.length - matchedToken[0]?.number_of_tokens : 1;

                return(
                    <div className="d-flex flex-wrap">
                        {selectedBookings?.length === 1 &&
                            <ProductCard
                                key={`token-${token.id}-one`}
                                item={token}
                                type={0}
                                name={`Add 1 ${token?.name}`}
                                price={token.id === cheapestId ? `$${price} (This is the cheapest token)` : price}
                                click={()=>handleSelectedProduct(token, "one")}
                            />
                        }
                        {matchedToken?.length > 1 && matchedTokens?.length < selectedBookings?.length &&
                            <ProductCard
                                key={`token-${token.id}-some`}
                                item={token}
                                type={0}
                                name={`Add Missing ${token.id === cheapestId ? "(Cheapest Token) " : ""} (${multiplier}) ${token?.name}`}
                                price={price * multiplier}
                                click={()=>handleSelectedProduct(token, "some")}
                            />
                        }
                        {selectedBookings?.length > 1 &&
                            <ProductCard
                                key={`token-${token.id}-all`}
                                item={token}
                                type={0}
                                name={`Add All (${selectedBookings?.length}) ${token?.name}${selectedBookings?.length > 1 ? "s" : ""} ${token.id === cheapestId ? "(Cheapest Token) " : ""}`}
                                price={price * selectedBookings?.length}
                                click={()=>handleSelectedProduct(token, "all")}
                            />
                        }
                    </div>
                )
            })}
            {fromPOS && 
                <p>
                    Remember! You are still able to add/remove tokens from the cart after completing this, but removal of too many tokens will make the booking incompletable.  
                    <br/>
                    Closing the order may result in a loss of the booking and may need to be recreated.
                </p>
            }
            {/* <p>
                <label htmlFor="override-tokens-true">Override Tokens</label>
                <Tooltip 
                    text="If you select this option, the user will just be added to the booking and not need to purchase a token."
                >
                    <i className="far fa-question-circle ms-1"/>
                </Tooltip>
                <input 
                    type="radio" 
                    id="override-tokens-true" 
                    name="override-tokens" 
                    value={1}
                    onChange={(e)=>console.log(e.target.value)}
                    label="Override"
                />
                <input 
                    type="radio" 
                    id="override-tokens-false" 
                    name="override-tokens" 
                    value={0}
                    onChange={(e)=>console.log(e.target.value)}
                />
            </p> */}
            <ErrorDiv errors={errors} />
        </div>
    )
}